/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Venues_SubtitleInputs */

const cs_settings_venues_subtitle = /** @type {(inputs: Settings_Venues_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pobočky této franšízy. Každý patří k pobočce. Pobočka může mít vlastní firmu, nebo převzít zastřešující firmu kanceláře.`)
};

const en_settings_venues_subtitle = /** @type {(inputs: Settings_Venues_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offices and branches of this franchise. Everyone belongs to an office. An office can use its own company or inherit the umbrella entity.`)
};

/**
* | output |
* | --- |
* | "Offices and branches of this franchise. Everyone belongs to an office. An office can use its own company or inherit the umbrella entity." |
*
* @param {Settings_Venues_SubtitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_venues_subtitle = /** @type {((inputs?: Settings_Venues_SubtitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Venues_SubtitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_venues_subtitle(inputs)
	return cs_settings_venues_subtitle(inputs)
});